export const roomIsDefault = {
  type: "boolean"
};
